import Application from 'components/Application';
import CustomersVoice from 'components/CustomersVoice';
import {TopFAQ} from 'components/FAQ';
import Layout from 'components/Layout';
import Price from 'components/Price';
import FirstView from 'components/FirstView';
import SEO from 'components/seo';
import React from 'react';
import Introduction from 'components/Introduction';

const ComachiPage = () => {
  return (
    <Layout>
      <SEO title='comachicart' />
      <FirstView/>
      <Introduction />
      <CustomersVoice />
      <Price visibleVoice={false} />
      <TopFAQ />
      <Application />
    </Layout>
  );
};

export default ComachiPage;